<script setup>
import { DmDropdownMenuItem, Icon } from 'dmui_components'

defineEmits(['retry:report'])
</script>

<template>
	<DmDropdownMenuItem id="retry-report-btn" @click="$emit('retry:report')">
		<Icon class="trash-icon" name="uil-redo" size="midi" />
		<span>Retry</span>
	</DmDropdownMenuItem>
</template>

<style scoped lang="less">
h1 > span {
	margin-left: @micro;
}
</style>
